import type { ReactNode } from 'react';

/**
 * Cadre centré des pages publiques d'authentification. Présentation uniquement : la logique
 * de formulaire vit dans chaque page.
 */
export function AuthCard({
  title,
  children,
  footer,
}: {
  title: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <main className="ddp-auth">
      <section className="ddp-auth__card">
        <h1 className="ddp-auth__brand">Drone Data Platform</h1>
        <h2 className="ddp-auth__title">{title}</h2>
        {children}
        {footer && <p className="ddp-auth__footer">{footer}</p>}
      </section>
    </main>
  );
}
